module.exports = "<footer class=\"app-footer\">\n  <span><a href=\"#\" target=\"_blank\">Fundação Rio Branco</a> &copy; {{ano}} - Todos os direitos reservados.</span>\n  <!--<span class=\"ml-auto\">Powered by <a href=\"http://oficina5.com.br\" target=\"_blank\">Oficina5</a></span>-->\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/app-footer/app-footer.component.html
// module id = ./src/app/shared/app-footer/app-footer.component.html
// module chunks = main